import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useLocation, useNavigate } from 'react-router-dom';
import withAuth from '../components/withAuth';

function LearnMore() {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeContent, setActiveContent] = useState(1);

  // Authentication check
  useEffect(() => {
    const isAuthenticated = localStorage.getItem('gallery3_authenticated') === 'true';
    if (!isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [navigate]);

  // Update activeContent based on the URL hash.
  useEffect(() => {
    if (location.hash) {
      const sectionNumber = parseInt(location.hash.replace('#', ''), 10);
      if (!isNaN(sectionNumber)) {
        setActiveContent(sectionNumber);
      }
    }
  }, [location.hash]);

  // Remove (or modify) any anchors with href="#" to avoid designesia.js error.
  useEffect(() => {
    if (window.jQuery) {
      const $ = window.jQuery;
      $('a[href="#"]').each(function() {
        $(this).attr('href', 'javascript:void(0)');
      });
    }
  }, []);

  // Handle sidebar menu clicks
  const handleMenuClick = (sectionNumber) => (e) => {
    e.preventDefault();
    setActiveContent(sectionNumber);
    navigate(`#${sectionNumber}`, { replace: true });
  };

  return (
    <div id="wrapper">
      {/* Header component */}
      <Header />

      <div className="no-bottom no-top" id="content">
        <section id="subheader" className="text-dark" />
        <section aria-label="section" style={{ paddingTop: 0 }}>
          <div className="container">
            <div className="row wow fadeIn">
              {/* Sidebar Menu */}
              <div className="col-lg-3 col-sm-6 col-xs-12 sidemenu">
                <ul>
                  <li>
                    <a
                      href="#1"
                      className={activeContent === 1 ? "active" : ""}
                      onClick={handleMenuClick(1)}
                    >
                      Getting started
                    </a>
                  </li>
                  <li>
                    <a
                      href="#2"
                      className={activeContent === 2 ? "active" : ""}
                      onClick={handleMenuClick(2)}
                    >
                      What's a wallet?
                    </a>
                  </li>
                  <li>
                    <a
                      href="#15"
                      className={activeContent === 15 ? "active" : ""}
                      onClick={handleMenuClick(15)}
                    >
                    How to set up a wallet
                    </a>
                  </li>
                  <li>
                    <a
                      href="#3"
                      className={activeContent === 3 ? "active" : ""}
                      onClick={handleMenuClick(3)}
                    >
                      What's a NFT?
                    </a>
                  </li>
                  <li>
                    <a
                      href="#4"
                      className={activeContent === 4 ? "active" : ""}
                      onClick={handleMenuClick(4)}
                    >
                      What's the point of buying an NFT if I can just download the picture?
                    </a>
                  </li>
                  <li>
                    <a
                      href="#5"
                      className={activeContent === 5 ? "active" : ""}
                      onClick={handleMenuClick(5)}
                    >
                      How do I get verified?
                    </a>
                  </li>
                  <li>
                    <a
                      href="#6"
                      className={activeContent === 6 ? "active" : ""}
                      onClick={handleMenuClick(6)}
                    >
                      Intellectual Property and Copyrights
                    </a>
                  </li>
                  <li>
                    <a
                      href="#7"
                      className={activeContent === 7 ? "active" : ""}
                      onClick={handleMenuClick(7)}
                    >
                      How to create a gallery?
                    </a>
                  </li>
                  <li>
                    <a
                      href="#8"
                      className={activeContent === 8 ? "active" : ""}
                      onClick={handleMenuClick(8)}
                    >
                      How to create a collection?
                    </a>
                  </li>
                  <li>
                    <a
                      href="#10"
                      className={activeContent === 10 ? "active" : ""}
                      onClick={handleMenuClick(10)}
                    >
                      Protect your NFTs
                    </a>
                  </li>
                  <li>
                    <a
                      href="#11"
                      className={activeContent === 11 ? "active" : ""}
                      onClick={handleMenuClick(11)}
                    >
                      Glry3 Token
                    </a>
                  </li>
                  <li>
                    <a
                      href="#13"
                      className={activeContent === 13 ? "active" : ""}
                      onClick={handleMenuClick(13)}
                    >
                      NFT Tickets
                    </a>
                  </li>
                  <li>
                    <a
                      href="#14"
                      className={activeContent === 14 ? "active" : ""}
                      onClick={handleMenuClick(14)}
                    >
                      What is TON blockchain?
                    </a>
                  </li>
                  <li>
                    <a
                      href="#9"
                      className={activeContent === 9 ? "active" : ""}
                      onClick={handleMenuClick(9)}
                    >
                      How to buy Toncoins?
                    </a>
                  </li>
                </ul>
              </div>

             
              <div className="col-lg-7 offset-lg-1" style={{ display: activeContent === 1 ? 'block' : 'none' }}>
                                {/* {<a href="create.html" className="fw-semibold" style={{ color: 'black' }}> Learn</a>} */}
                                <h1 className="pb-30 title-mt">Getting started</h1>
                                <p style={{ fontSize: '20px' }}>
                                    Gallery3 want to help artists and small galleries to launch blockchain-native art projects and curated NFT collections. By marrying the tactile appeal of physical art with the dynamic possibilities of digital platforms, Gallery3 is not only expanding the horizons for artists but also enriching the art collecting experience for enthusiasts around the globe.<br /><br />
                                    {/* Unique to Gallery3 is the inclusion of a phygital element with digital art NFTs. During primary sale of every NFT collection, collectors have the option to acquire a physical print of their digital art piece, offered as a bundle. These physical artworks are represented as print vouchers NFTs, which can be freely traded on NFT marketplaces. */}
                                    The Gallery3 platform innovatively caters to both Web3 collectors and traditional art enthusiasts by offering a dedicated marketplace for trading art. This initiative enhances the value of the Gallery3 collection, providing liquidity for Web3 collectors and unique acquisition opportunities for traditional collectors. Through this marketplace, Gallery3 is setting a new standard for the ownership and enjoyment of fine art, making exclusive prints accessible to a wider audience than ever before.
                                </p>
                                {/* <h2>
                                    Phygital Artworks: bridging digital with physical
                                </h2> */}

                            </div>
                            <div className="col-lg-7 offset-lg-1" style={{ display: activeContent === 2 ? 'block' : 'none' }}>
                                {/* {<a href="create.html" className="fw-semibold" style={{ color: 'black' }}> Learn</a>} */}
                                <h1 className="pb-30 title-mt">What's a wallet?</h1>
                                <p style={{ fontSize: '20px' }}>
                                    A wallet is not a physical object like a traditional wallet; instead, it is a digital vault that allows users to store, manage, and transfer their digital assets securely:<br /><br />
                                    <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
                                        <li style={{ paddingBottom: 10 }}><strong>Storage</strong><br />
                                            Wallets securely store NFTs, ensuring that ownership and authenticity are protected. Each NFT is linked to a unique identifier on the blockchain that can be accessed only through the owner's wallet.</li>

                                        <li style={{ paddingBottom: 10 }}><strong>Transactions</strong><br />
                                            To buy, sell, or trade NFTs on marketplaces, users must link their wallets to their marketplace accounts. This linkage facilitates secure transactions using cryptocurrencies.</li>

                                        <li style={{ paddingBottom: 10 }}><strong>Management</strong><br />
                                            Wallets allow users to manage their entire collection of NFTs efficiently. They provide the ability to view details about each token and track its value over time.</li>

                                        <li style={{ paddingBottom: 10 }}><strong>Security Features</strong><br />
                                            Many wallets incorporate advanced security features—such as two-factor authentication and encryption—to protect against unauthorized access.</li>
                                    </ul>
                                </p>
                            </div>

                            <div className="col-lg-7 offset-lg-1" style={{ display: activeContent === 3 ? 'block' : 'none' }}>
                                {/* {<a href="create.html" className="fw-semibold" style={{ color: 'black' }}> Learn</a>} */}
                                <h1 className="pb-30 title-mt">What's a NFT?</h1>

                                <p style={{ fontSize: '20px' }}>
                                    
                                </p>
                            </div>

                            <div className="col-lg-7 offset-lg-1" style={{ display: activeContent === 4 ? 'block' : 'none' }}>
                                {/* {<a href="create.html" className="fw-semibold" style={{ color: 'black' }}> Learn</a>} */}
                                <h1 className="pb-30 title-mt">What's the point of buying an NFT if I can just download the picture?</h1>

                                <p style={{ fontSize: '20px' }}>
                                    The answer to that question lies in the concept of NFTs. Yes, you can, in fact, simply download whatever picture you can find on the internet. However, it's next to impossible to determine who owns the original, except for the owner of the NFT, which means that the NFT's value rests in the hands of its owner — and no one else.
                                    <br />
                                    Also don't forget that picture is just a representation of the NFT. You own not the JPG itself, but the utility behind it.
                                </p>
                            </div>

                            <div className="col-lg-7 offset-lg-1" style={{ display: activeContent === 5 ? 'block' : 'none' }}>
                                {/* {<a href="create.html" className="fw-semibold" style={{ color: 'black' }}> Learn</a>} */}
                                <h1 className="pb-30 title-mt">How do I get verified?</h1>

                                <p style={{ fontSize: '20px' }}>
                                    Getting verified
                                    Highlight verifies creators on a case-by-case basis to protect collectors. Creators who are verified will have a badge next to their name.

                                    Note: Lack of verification does not restrict the use of Highlight, but being verified helps enhance trust and authenticity for others.

                                    How to get verified
                                    To get verified, follow these steps:

                                    Link your Twitter account to your profile page. This will help our team verify your online identity and that your user profile is directly associated with your Twitter account

                                    Then, fill out the form here

                                    Currently we're only offering verification for creators. However, if you are a collector, you may still fill the form out. This data will be used later on when and if we prioritize collector verification.

                                    Our team reviews verification submissions a few times a week. We will reach out via email if your account has been verified.

                                    Verification criteria
                                    To obtain the verification badge, our team looks for the following:

                                    History of work: this can either be on Highlight or another platform where you've released work

                                    Verifiable online identity: we'll review your other social accounts such as Twitter, Instagram, and Farcaster  to gauge when they were created and signs of recent activity.

                                    Losing your verification
                                    If you engage in any activity that violates our Terms of Service, we reserve the right to revoke verification.                                </p>
                            </div>

                            <div className="col-lg-7 offset-lg-1" style={{ display: activeContent === 6 ? 'block' : 'none' }}>
                                {/* {<a href="create.html" className="fw-semibold" style={{ color: 'black' }}> Learn</a>} */}
                                <h1 className="pb-30 title-mt">Intellectual Property and Copyrights</h1>

                                <p style={{ fontSize: '20px' }}>
                                Intellectual Property and Copyrights

                                </p>
                            </div>

                            <div className="col-lg-7 offset-lg-1" style={{ display: activeContent === 11 ? 'block' : 'none' }}>
                                {/* {<a href="create.html" className="fw-semibold" style={{ color: 'black' }}> Learn</a>} */}
                                <h1 className="pb-30 title-mt">Glry3 Token</h1>

                                <p style={{ fontSize: '20px' }}>

                                    The $GLRY3 token is the native token of the Gallery3 platform. The following are the high-level $GLRY3 utilities for the platform:

                                    <br />
                                    A tiered collector system based on staking of the $ART token and platform participation will provide collectors with early access to sales, lowered trading fees, access to yield, governance decisions, discounts on premium purchases, and access to LiveArt's unique guarantor program.
                                    <br />

                                    Referral Incentives: Live Art implements a referral program where existing users earn by referring participants. Referred users also receive a one-time bonus when they participate in their first sale.

                                    Exclusive Community Access: ART token holders gain access to an exclusive LiveArt community. Benefits include direct interactions with featured artists, previews of upcoming art launches, and the opportunity to propose and vote on community-driven art projects.

                                    Rewards
                                    $ART is your gateway to the art world, granting unprecedented access to data, the digital art by leading artists and initial fraction offerings.

                                    $ART utility token is a reward provided to users of the LiveArt network of partners that can be used in exchange for enhanced art collecting experiences and digital art. Combined with The LiveArt Pass, a membership card providing holders with governance, users have the opportunity to earn accelerated $ART rewards to reach their collecting milestones faster and to enable them to connect with a community of artists and like-minded collectors.

                                    While users do not need to hold a LiveArt Pass to earn $ART, card holders earn more $ART for every qualifying action and are able to access unique $ART utility unavailable to non-holders.

                                </p>


                            </div>
                            <div className="col-lg-7 offset-lg-1" style={{ display: activeContent === 7 ? 'block' : 'none' }}>
                                {/* {<a href="create.html" className="fw-semibold" style={{ color: 'black' }}> Learn</a>} */}
                                <h1 className="pb-30 title-mt">How to create a gallery?</h1>

                                <p style={{ fontSize: '20px' }}>
                                How to create a gallery?
                                </p>
                            </div>
                            <div className="col-lg-7 offset-lg-1" style={{ display: activeContent === 8 ? 'block' : 'none' }}>
                                {/* {<a href="create.html" className="fw-semibold" style={{ color: 'black' }}> Learn</a>} */}
                                <h1 className="pb-30 title-mt">How to create a collection?</h1>

                                <p style={{ fontSize: '20px' }}>
                                How to create a collection?                                </p>
                            </div>
                            <div className="col-lg-7 offset-lg-1" style={{ display: activeContent === 9 ? 'block' : 'none' }}>
                                {/* {<a href="create.html" className="fw-semibold" style={{ color: 'black' }}> Learn</a>} */}
                                <h1 className="pb-30 title-mt">How to buy Toncoins??</h1>

                                <p style={{ fontSize: '20px' }}>
                                How to create a collection?                                </p>
                            </div>
                            <div className="col-lg-7 offset-lg-1" style={{ display: activeContent === 10 ? 'block' : 'none' }}>
                                {/* {<a href="create.html" className="fw-semibold" style={{ color: 'black' }}> Learn</a>} */}
                                <h1 className="pb-30 title-mt">Protect your NFTs</h1>

                                <p style={{ fontSize: '20px' }}>
                                How to create a collection?                                </p>
                            </div>
                            <div className="col-lg-7 offset-lg-1" style={{ display: activeContent === 13 ? 'block' : 'none' }}>
                                {/* {<a href="create.html" className="fw-semibold" style={{ color: 'black' }}> Learn</a>} */}
                                <h1 className="pb-30 title-mt">NFT Tickets</h1>

                                <p style={{ fontSize: '20px' }}>
                                How to create a collection?                                </p>
                            </div>
                            <div className="col-lg-7 offset-lg-1" style={{ display: activeContent === 13 ? 'block' : 'none' }}>
                                {/* {<a href="create.html" className="fw-semibold" style={{ color: 'black' }}> Learn</a>} */}
                                <h1 className="pb-30 title-mt">Protect your NFTs</h1>

                                <p style={{ fontSize: '20px' }}>
                                How to create a collection?                                </p>
                            </div>
                            <div className="col-lg-7 offset-lg-1" style={{ display: activeContent === 14 ? 'block' : 'none' }}>
                                {/* {<a href="create.html" className="fw-semibold" style={{ color: 'black' }}> Learn</a>} */}
                                <h1 className="pb-30 title-mt">What is TON blockchain?</h1>

                                <p style={{ fontSize: '20px' }}>
                                How to create a collection?                                </p>
                            </div>
                            <div className="col-lg-7 offset-lg-1" style={{ display: activeContent === 15 ? 'block' : 'none' }}>
                                {/* {<a href="create.html" className="fw-semibold" style={{ color: 'black' }}> Learn</a>} */}
                                <h1 className="pb-30 title-mt">How to set up a wallet</h1>

                                <p style={{ fontSize: '20px' }}>
                                Hosa                                </p>
                            </div>
            </div>
          </div>
        </section>
      </div>

      {/* Footer component */}
      <Footer />
    </div>
  );
}

export default withAuth(LearnMore);

